import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container, Button, Alert } from "react-bootstrap";
import "./add-levels.css";
import {
  getLevel1Data,
  uploadLevel5File,
  getLevelOneName,
  getLevelTwoName,
  deleteLevel5,
  getLevelFourName,
} from "./accountsLevel.action";
import { connect } from "react-redux";
import { isEmpty, find } from "lodash";
import Spinner from "react-bootstrap/Spinner";
import Select from "react-select";
import Swal from "sweetalert";

const Level5Upload = (props) => {
  const [level1data, setLevel1data] = useState();
  const [level2Data, setLevel2data] = useState();
  const [level3Data, setLevel3Data] = useState();

  const [level1Id, setLevel1Id] = useState();
  const [level2Id, setLevel2Id] = useState();
  const [level3Id, setLevel3Id] = useState();

  const [level4Id, setLevel4Id] = useState();
  const [level4Data, setLevel4Data] = useState();
  const [level5File, setLevel5File] = useState();
  const [visibleAlert, setAlertVisible] = useState(false);
  const [dangerVisibleAlert, setDangerVisibleAlert] = useState(false);

  const handleVisible = () => {
    setAlertVisible(true);
    setTimeout(() => {
      setAlertVisible(false);
    }, 9000);
    Swal({
      title: "Success",
      text: "Added successfully...",
      icon: "success",
      button: "Ok",
    });
  };

  const handleDangerVisible = () => {
    setDangerVisibleAlert(true);
    setTimeout(() => {
      setDangerVisibleAlert(false);
    }, 9000);
    Swal({
      title: "Error",
      text: "Something went wrong...",
      icon: "error",
      button: "Ok",
    });
  };

  function uploadFileLevel5() {
    props.uploadLevel5File(
      {
        levelOneId: level1Id,
        levelTwoId: level2Id,
        levelThreeId: level3Id,
        levelFourId: level4Id,
        file: level5File,
      },
      handleVisible,
      handleDangerVisible
    );
    setLevel1data("");
    setLevel2data("");
    setLevel3Data("");
    setLevel4Data("");
  }

  const getLevelFourList =
    !isEmpty(props.levelFour) &&
    props.levelFour.map((x) => {
      let data = {
        value: x.levelTwoData.levelFourId,
        label: x.levelTwoData.levelFourName,
      };
      return data;
    });
  const handleChangeLevel4 = (selectedOption) => {
    setLevel4Data(selectedOption.value);
    setLevel4Id(selectedOption.value);
    // setLevel1Id(find(props.level4List, x => x.levelFourData.levelFourId == selectedOption.value).levelFourData.levelOneId);
    // setLevel2Id(find(props.level4List, x => x.levelFourData.levelFourId == selectedOption.value).levelFourData.levelTwoId);
    // setLevel3Id(find(props.level4List, x => x.levelFourData.levelFourId == selectedOption.value).levelFourData.levelThreeId);
  };

  // add level
  const getLevel1List = props.level1List.map((x) => {
    let data = { value: x.levelOneId, label: x.name };
    return data;
  });
  const handleChangeLevel1 = (selectedOption) => {
    props.getLevelOneName(selectedOption.value);
    setLevel1Id(selectedOption.value);
    setLevel1data(selectedOption.label);
    setLevel2Id(selectedOption.value);
    setLevel2data(selectedOption.label);
    props.getLevelTwoName(selectedOption.value);
  };
  const getLevelTwoList =
    !isEmpty(props.levelTow) &&
    props.levelTow.map((x) => {
      let data = {
        value: x.levelTwoData.levelTwoId,
        label: x.levelTwoData.levelTwoName,
      };
      return data;
    });
  const handleChangeLevel2 = (selectedOption) => {
    setLevel2Id(selectedOption.value);
    setLevel2data(selectedOption.label);
    props.getLevelTwoName(selectedOption.value);
    // setLevel1Id(find(props.level2List, x => x.levelTwoData.levelTwoId == selectedOption.value).levelTwoData.levelOneId)
  };
  const getlevel3val =
    !isEmpty(props.levelThree) &&
    props.levelThree.map((x) => {
      let data = {
        value: x.levelTwoData.levelThreeId,
        label: x.levelTwoData.levelThreeName,
      };
      return data;
    });
  const handleChangeLevel3 = (selectedOption) => {
    props.getLevelFourName(selectedOption.value);
    setLevel3Id(selectedOption.value);
    setLevel3Data(selectedOption.label);
    // setLevel1Id(find(props.level3List, x => x.levelThreeData.levelThreeId == selectedOption.value).levelThreeData.levelOneId);
    // setLevel2Id(find(props.level3List, x => x.levelThreeData.levelThreeId == selectedOption.value).levelThreeData.levelTwoId)
  };

  // const getLevel4List = !isEmpty(props.level4List) && props.level4List.map((x) => { let data = { value: x.levelFourData.levelFourId, label: x.levelFourData.levelFourName }; return data });
  // const handleChangeLevel4 = (selectedOption) => {
  //     setLevel4Id(selectedOption.value);
  //     setLevel1Id(find(props.level4List, x => x.levelFourData.levelFourId == selectedOption.value).levelFourData.levelOneId);
  //     setLevel2Id(find(props.level4List, x => x.levelFourData.levelFourId == selectedOption.value).levelFourData.levelTwoId);
  //     setLevel3Id(find(props.level4List, x => x.levelFourData.levelFourId == selectedOption.value).levelFourData.levelThreeId);
  // };

  useEffect(() => {}, []);
  return (
    <>
      {props.isFetchinglevel1List ||
      props.isFetchingLevelTow ||
      props.isFetchingLevelThree ||
      props.isFetchingLevelFour ? (
        <div className="loader-div">
          <Button variant="info" disabled>
            <Spinner
              animation="grow"
              size="sm"
              role="status"
              aria-hidden="true"
              variant="info"
            />
          </Button>
        </div>
      ) : (
        <Container fluid>
          <div className="main">
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label>
                    <b> Select Level 1 </b>
                  </Form.Label>
                  <Select
                    value={{ label: level1data }}
                    placeholder="Select Level 1..."
                    onChange={handleChangeLevel1}
                    options={getLevel1List}
                  />
                </Form.Group>
              </Col>
            </Row>
            {/* <Row>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label>
                                                    <b> Select Level 2 </b>
                                                </Form.Label>
                                                <Select
                                                 isDisabled={isEmpty(getLevelTwoList) || isEmpty(level1data)}
                                                
                                                 value = {{label: level2Data}}
                                                    placeholder="Select Level 2..."
                                                     onChange={handleChangeLevel2}
                                                      options={getLevelTwoList}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row> */}
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label>
                    <b> Select Level 2 </b>
                  </Form.Label>
                  <Select
                    isDisabled={isEmpty(getlevel3val) || isEmpty(level1data)}
                    value={{ label: level3Data }}
                    placeholder="Select Level 3..."
                    onChange={handleChangeLevel3}
                    options={getlevel3val}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label>
                    <b> Select Level 3 </b>
                  </Form.Label>
                  <Select
                    isDisabled={
                      isEmpty(getLevelFourList) || isEmpty(level3Data)
                    }
                    value={{ label: level4Data }}
                    placeholder="Select Level 4..."
                    onChange={(e) => handleChangeLevel4(e)}
                    options={getLevelFourList}
                  />
                </Form.Group>
              </Col>
            </Row>

            <div style={{ paddingTop: "2%" }}>
              <Row>
                <Col xl="4" lg="4" md="2" sm="2" xs="2"></Col>
                <Col xl="4" lg="4" md="4" sm="4" xs="4">
                  <Form.Group>
                    <Form.Label>
                      <b style={{ fontSize: "x-large" }}>Upload Level 4 File</b>
                    </Form.Label>
                    <input
                      className="form-control"
                      type="file"
                      name="file"
                      class="Upload File"
                      id="upload file"
                      onChange={(e) => setLevel5File(e.target.files[0])}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </div>
            <div className="sendDiv" style={{marginTop:'15px'}}>
              {!level4Id ? (
                <Button
                  disabled
                  style={{
                    marginLeft: "2%",
                    color: "white",
                    width: "20%",
                    backgroundColor: "black",
                    border: "1px solid black",
                  }}
                >
                  Save
                </Button>
              ) : (
                <Button className="sendButton" onClick={uploadFileLevel5}>
                  Save
                </Button>
              )}
            </div>
          </div>
        </Container>
      )}
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    getLevel1Data: () => dispatch(getLevel1Data()),
    uploadLevel5File: (data, handleVisible, handleDangerVisible) =>
      dispatch(uploadLevel5File(data, handleVisible, handleDangerVisible)),
    getLevelOneName: (data) => dispatch(getLevelOneName(data)),
    getLevelTwoName: (data) => dispatch(getLevelTwoName(data)),
    getLevelFourName: (data) => dispatch(getLevelFourName(data)),
  };
};
const mapStateToProps = (state, ownProps) => ({
  level1List: state.accountsLevelReducer.level1List,
  levelTow: state.accountsLevelReducer.levelTow,
  levelThree: state.accountsLevelReducer.levelThree,
  levelFour: state.accountsLevelReducer.levelFour,
  level4List: state.accountsLevelReducer.level4List,
  isAddingLevel5File: state.accountsLevelReducer.isAddingLevel5File,
  isnotAddingLevel5File: state.accountsLevelReducer.isnotAddingLevel5File,
  isFetchinglevel1List: state.accountsLevelReducer.isFetchinglevel1List,
  isFetchingLevelTow: state.accountsLevelReducer.isFetchingLevelTow,
  isFetchingLevelThree: state.accountsLevelReducer.isFetchingLevelThree,
  isFetchingLevelFour: state.accountsLevelReducer.isFetchingLevelFour,
});

export default connect(mapStateToProps, mapDispatchToProps)(Level5Upload);
